import type { CompanyInfoResponse } from '../types/api/response/companyInfo';
import { MS_HIFIVEWORK_PROFILE_ENDPOINT } from '../variables/GlobalVariables';
import request from './AxiosClient';

function getCompanyInfo(companyId: string): Promise<CompanyInfoResponse> {
  return request
    .get(`${MS_HIFIVEWORK_PROFILE_ENDPOINT}/v2/company/${companyId}/info`)
    .then((res) => res?.data);
}

const CompanyInfoService = {
  getCompanyInfo,
};

export default CompanyInfoService;
